export function getItems() {
  return [
    {to: {name: 'AdminDashboard'}, label: 'Dashboard', icon: 'icon-Dashboard'},
    {to: { name: 'AdminCompanies'}, label: 'Companies', icon: 'icon-Settings' },
    {to: {name: 'AdminDemandPartners'}, label: 'Bidders', icon: 'icon-Demand'},
    {to: { name: 'AdminExchangeList'}, label: 'Exchanges', icon: 'icon-Settings' },
    {to: { name: 'AdminPublisherList'}, label: 'Publishers', icon: 'icon-Settings' },
    {to: {name: 'AdminPublicDeals'}, label: 'Deals'},
    {to: {name: 'AdminActivity'}, label: 'Reports', icon: 'icon-Reports'},
    {to: {name: 'AdminExplorer'}, label: 'Explorer', icon: 'icon-Reports'},
    {to: {name: 'AdminInspections'}, label: 'Inspections', icon: 'icon-Reports'},
    // {to: {name: 'AdminAdApprovals'}, label: 'Approvals', icon: 'icon-Reports'},
    // {to: {name: 'AdminScanTabs'}, label: 'Scans'},
    {to: {name: 'AdminGlobalConfig'}, label: 'Pixel'},
    {to: {name: 'AdminNodes'}, label: 'Nodes'}
  ]
}



// WEBPACK FOOTER //
// ./src/admin/menuitems.js